module.exports = __webpack_public_path__ + "img/p_dn.f093de5a.svg";